// extracted by mini-css-extract-plugin
export default {"header":"ExplorerHeader_header__+2a2L","title":"ExplorerHeader_title__eipH6"};